module.exports = __webpack_public_path__ + "static/media/NP.9f2d8bc5.svg";